import React from 'react';
import {STATUS_LOCALIZATION} from "constants/status";
import {FormattedMessage} from "react-intl";
import {STATUS} from "constants/status";

const getStatusColor = (status) => {
  switch (status) {
    case STATUS.HANDED_OVER:
      return "bg-[#64b978]";
    case STATUS.DRAFT:
      return "bg-[#9A9FB0]";
    case STATUS.REJECTED:
      return "bg-[#c05056]";
    case STATUS.NEED_MORE_INFO:
      return "bg-[#e9a658]";
    case STATUS.CANCELED:
      return "bg-[#c05056]";
    default:
      return "bg-[#4164DA]";
  }
};

const StatusTag = ({status, ...props}) => (
  <div 
    className={`${getStatusColor(status)} rounded px-2 py-1 text-white inline-block uppercase text-xs font-bold leading-none text-center`}
    {...props}
  >
    <FormattedMessage id={STATUS_LOCALIZATION[status]}/>
  </div>
);

export default StatusTag;


